import { UserProcedure } from '@/Domain/Procedures'

export class UserProcedureDto {
  private _procedureId: string
  private _procedureType: string
  private _procedureStatus: string
  private _provinceCode: number
  private _publishDate: string
  private _dogaUrl: string
  private _dogaNumber: number
  private _limitDate: string
  private _celebrationPlace: string
  private _celebrationDate: string
  private _celebrationTime: string
  private _applicationStatus: string
  private _batches: string

  static fromUserProcedure (userProcedure: UserProcedure): UserProcedureDto {
    const translatedStatus = userProcedure.status() as string
    return new UserProcedureDto(
      userProcedure.procedureId(),
      userProcedure.procedureType(),
      translatedStatus,
      userProcedure.province(),
      userProcedure.dogaDate(),
      userProcedure.dogaUrl(),
      userProcedure.dogaNumber(),
      userProcedure.dateLimit(),
      userProcedure.celebrationPlace(),
      userProcedure.celebrationDate(),
      userProcedure.celebrationTime(),
      userProcedure.applicationStatus(),
      userProcedure.batches()
    )
  }

  constructor (
    procedureId: string,
    procedureType: string,
    procedureStatus: string,
    provinceCode: number,
    publishDate: string,
    dogaUrl: string,
    dogaNumber: number,
    limitDate: string,
    celebrationPlace: string,
    celebrationDate: string,
    celebrationTime: string,
    applicationStatus: string,
    batches: string
  ) {
    this._procedureId = procedureId
    this._procedureType = procedureType
    this._procedureStatus = procedureStatus
    this._provinceCode = provinceCode
    this._publishDate = publishDate
    this._dogaUrl = dogaUrl
    this._dogaNumber = dogaNumber
    this._limitDate = limitDate
    this._celebrationPlace = celebrationPlace
    this._celebrationDate = celebrationDate
    this._celebrationTime = celebrationTime
    this._applicationStatus = applicationStatus
    this._batches = batches
  }

  get procedureId (): string {
    return this._procedureId
  }

  get procedureType (): string {
    return this._procedureType
  }

  get procedureStatus (): string {
    return this._procedureStatus
  }

  get provinceCode (): number {
    return this._provinceCode
  }

  get publishDate (): string {
    return this._publishDate
  }

  get dogaUrl (): string {
    return this._dogaUrl
  }

  get dogaNumber (): number {
    return this._dogaNumber
  }

  get limitDate (): string {
    return this._limitDate
  }

  get celebrationPlace (): string {
    return this._celebrationPlace
  }

  get celebrationDate (): string {
    return this._celebrationDate
  }

  get celebrationTime (): string {
    return this._celebrationTime
  }

  get applicationStatus (): string {
    return this._applicationStatus
  }

  get batches (): string {
    return this._batches
  }
}
